<template>
  <section v-if="anyBuildData">
    <VehicleInfo @showPhotos="showPhotos" />
    <ZTabs v-model="currentTab" :tabs="tabs" @change="setTab" />
    <div class="custom-wrapper">
      <!-- <div v-if="currentTab === 'Features'" class="row p-1">
        <Features />
      </div> -->
      <div v-if="currentTab === 'Installed Equipment'" class="row p-1">
        <InstalledEquipment />
      </div>
      <div v-if="currentTab === 'Installed Options'" class="row p-1">
        <InstalledOptions />
      </div>
      <div v-if="currentTab === 'Pricing'" class="row p-1">
        <Pricing />
      </div>
    </div>
  </section>
  <section v-else class="custom-center">
    <h5 class="text-danger">No Build Data Available</h5>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { buildStore } from '@/stores/build'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import Features from '@/components/build/forms/Features.vue'
import VehicleInfo from './VehicleInfo.vue'
import InstalledEquipment from '@/components/build/forms/InstalledEquipment.vue'
import InstalledOptions from '@/components/build/forms/InstalledOptions.vue'
import Pricing from '@/components/build/forms/Pricing.vue'
export default {
  name: 'vehicle-summary',
  components: {
    ZTabs,
    VehicleInfo,
    Features,
    InstalledEquipment,
    InstalledOptions,
    Pricing
  },
  data() {
    return {
      tabs: ['Installed Equipment', 'Installed Options', 'Pricing'],
      currentTab: 'Installed Equipment',
      actionPhotos: null,
      actionInstalled: null,
      actionOptions: null,
      actionPricing: null
    }
  },
  computed: {
    ...mapState(buildStore, ['build']),
    anyBuildData() {
      let _any = true
      if (this.build) {
        if (this.build.error !== undefined && this.build.error !== null) {
          _any = false
        }
      }
      return _any
    }
  },
  methods: {
    closeModal() {
      this.actionPhotos = null
      this.actionInstalled = null
      this.actionOptions = null
      this.actionPricing = null
    },
    setTab(tab) {
      this.currentTab = tab
    },
    viewInstalledEquip() {
      this.actionInstalled = true
    },
    viewInstalledOptions() {
      this.actionOptions = true
    },
    showPhotos() {
      this.actionPhotos = true
    },
    viewPricing() {
      this.actionPricing = true
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-features {
  width: 100%;
  max-height: 450px;
  overflow-x: hidden;
  overflow-y: auto;
}

.custom-installs {
  padding-top: 15px;
}

.custom-center {
  text-align: center;
}

.custom-wrapper {
  width: 100%;
  max-height: 560px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
